import { Injectable } from '@angular/core';
import { SelectOptionLoaderI } from '../../../../../../shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { select, Store } from '@ngrx/store';
import { OrderBuilderState, getFirstCalendar } from '../../../../../reducers';
import { UntypedFormGroup } from '@angular/forms';
import { SelectOptionI } from '../../../../../../shared/modules/configurable-form/components/form-multiselect/models/select-option-i';
import { Observable } from 'rxjs';
import { getTemperatures } from '../../../selectors/single-catalogs';
import { filter, map, take, withLatestFrom } from 'rxjs/operators';
import { getTemperatureVaps } from '../../../selectors/added-value.selectors';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { getRefrigerantValueAdded } from '@ordersnproducts/utils/temperature.util';

@Injectable()
export class TemperatureOptionLoaderService implements SelectOptionLoaderI {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   * Provides an observable of the products
   * @return {Observable<SelectOptionI[]>}
   */
  loadOptions(formGroup: UntypedFormGroup): Observable<SelectOptionI[]> {
    const vaps$ = this.store.select(getTemperatureVaps);
    const calendar$ = this.store.select(getFirstCalendar).pipe(
      filter((calendar) => !!calendar),
      take(1),
      );
    return this.store.pipe(
      select(getTemperatures),
      withLatestFrom(vaps$, calendar$),
      map(([temperatures, vaps, calendar]) => {
        const formId = _safe(() => Number(formGroup.value.id));

        const refrigerant = _safe(() => getRefrigerantValueAdded(vaps[formId], calendar.tempControlFlag), undefined);

        if (refrigerant && temperatures.length) {
          return temperatures.map((temperature) => {
            return {
              id: temperature.featureCode,
              name: `${temperature.featureDescription}`,
            };
          });
        }
        return [];
      }),
    );
  }
}
